"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _heart = _interopRequireDefault(require("cccisd-icons/heart3"));
var _heart2 = _interopRequireDefault(require("cccisd-icons/heart4"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Fortress = window.cccisd.fortress;
var FavoriteButton = function FavoriteButton(_ref) {
  var color = _ref.color,
    resource = _ref.resource,
    useFavorite = _ref.useFavorite;
  if (!Fortress.auth()) {
    return /*#__PURE__*/_react["default"].createElement("span", null);
  }
  var _useFavorite = useFavorite(resource),
    isFavorited = _useFavorite.isFavorited,
    toggleFavorite = _useFavorite.toggleFavorite;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: _style["default"].button,
    onClick: toggleFavorite,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fs-4",
    style: {
      color: isFavorited ? color : 'inherit'
    }
  }, isFavorited ? /*#__PURE__*/_react["default"].createElement(_heart["default"], null) : /*#__PURE__*/_react["default"].createElement(_heart2["default"], null)));
};
FavoriteButton.propTypes = {
  color: _propTypes["default"].string,
  resource: _propTypes["default"].object.isRequired,
  useFavorite: _propTypes["default"].func.isRequired
};
FavoriteButton.defaultProps = {
  color: '#E84C3D' // red (heart)
};
var _default = exports["default"] = FavoriteButton;